@if (!shareError && sharingEnabled && socialNetworks) {
  <div id="ticketshare">
    @if (!shareSuccess) {
      <div class="clearfix">
        <button class="direct-url-share" (click)="share()" [loading]="shareLoading">
          <i class="fas fa-share mr-2"></i>
          <span class="ml-1 share-ticket-text" [transloco]="'buttons.SHARE_TICKET'"></span>
          <span class="ml-1 share-cashout-text" [transloco]="'buttons.SHARE_CASHOUT'"></span>
        </button>
      </div>
    }
    @if (shareSuccess) {
      <div class="sharing-buttons">
        @if (isMobileDevice() && socialNetworks.whatsapp) {
          <div class="sharing-button-item wa" (click)="whatsapp()">
            <i class="fab fa-whatsapp" aria-hidden="true"></i>
          </div>
        }
        @if (socialNetworks.twitter) {
          <div class="sharing-button-item twitter" (click)="openLink(shareData.twitterUrl)">
            <i class="fa-brands fa-x-twitter" aria-hidden="true"></i>
          </div>
        }
        @if (socialNetworks.facebook) {
          <div class="sharing-button-item fb" (click)="openLink(shareData.facebookUrl)">
            <i class="fab fa-facebook-f" aria-hidden="true"></i>
          </div>
        }
        <div class="sharing-button-item link" [ngClass]="{'completed': linkCopied()}" (click)="copyLink($event)">
          @if (!linkCopied() && !linkCopyFailed()) {
            <i class="far fa-link link-icon mr-1.5" aria-hidden="true"></i>
            <span [transloco]="'syndicateJoin.COPY_LINK'"></span>
          }
          @if (linkCopied()) {
            <span [transloco]="'syndicateJoin.LINK_COPIED'"></span>
          }
          @if (linkCopyFailed()) {
            <span [transloco]="'syndicateJoin.LINK_COPY_FAILED'"></span>
          }
        </div>
      </div>
    }
  </div>
}
